"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Divider = ({ base, style, direction = 'horizontal', dividerColor, customClass }) => {
    const DividerCN = (base = false, dividerColor = '', customClass = '') => {
        return (0, classnames_template_literals_1.default)(`
          ${direction === 'horizontal' ? 'w-full h-[1px]' : 'w-[1px] h-full'}
          ${base ? 'bg-v-600' : dividerColor ? dividerColor : 'bg-n-400'}
          ${customClass}
        `);
    };
    return (react_1.default.createElement("div", { className: DividerCN(base, dividerColor, customClass), style: style }));
};
exports.default = Divider;
